import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import FormRow from "../../../gd-form/form/form-ui5/form-row"
import FormError from "../../../gd-form/common/form-error/form-error"
import {
    RequestForm_FieldTreatAs
} from "../../../../app/tools/request-forms2/const/const"
import FieldProto from "../../../fields3/proto/field-proto"
import {FieldType} from "../../../fields3/field-type"
import SelectGenericNew from "../../../gd-ui/select-generic-new/select-generic-new"

type Props = {
    field   : FieldProto
    form    : FormManager
}

export default function CustomField_FormRowTreatAs(props:Props) {

    const onChangeTreatAs = (option?: Option) => {
        props.form.onFormComponentValueChange("treatAs", option?.value)
    }

    const options: Option[] = [
        {
            value       : RequestForm_FieldTreatAs.USER_NAME,
            label       : "User Name",
            disabled    : props.field.type !== FieldType.STRING
        },
        {
            value       : RequestForm_FieldTreatAs.USER_EMAIL,
            label       : "User Email",
            disabled    : props.field.type !== FieldType.EMAIL
        },
        {
            value       : RequestForm_FieldTreatAs.USER_PHONE,
            label       : "User Phone",
            disabled    : props.field.type !== FieldType.PHONE
        }
    ]

    return (
        <FormRow label="Use as">
            <SelectGenericNew className                     = "selector w-300"
                              options                       = {options}
                              placeholder                   = "Default"
                              noValueOption                 = {true}
                              noValueOptionLabel            = "Default"
                              value                         = {props.form.getValue("treatAs")}
                              popoverScrollContainerClasses = "max-h-200 w-300"
                              onChange                      = {onChangeTreatAs}/>
            <FormError form={props.form} name="treatAs"/>
        </FormRow>
    )
}
